import { Globals } from '../../modules/Globals';
import axios from 'axios';
import ICustomField from '../../interfaces/ICustomField';
import { IOrder } from '../../interfaces/IOrder';

const apiUrl = Globals.apiPath + '/customFields';

export default class CustomFieldsService {
  constructor() {}

  static async getAll(
    restaurantId: number,
    branchId: number
  ): Promise<ICustomField[]> {
    let res = await axios.get<ICustomField[]>(
      `${apiUrl}?r=${restaurantId}&b=${branchId}`
    );
    return res.data;
  }

  async saveBatch(
    restaurantId: number,
    branchId: number,
    customFields: ICustomField[]
  ): Promise<ICustomField[]> {
    let res = await axios.put<ICustomField[]>(`${apiUrl}/batch`, {
      restaurantId,
      branchId,
      fields: customFields,
    });
    return res.data;
  }

  async create(customField: ICustomField): Promise<ICustomField> {
    let res = await axios.post<ICustomField>(apiUrl, customField);
    return res.data;
  }

  async update(customField: ICustomField): Promise<ICustomField> {
    let res = await axios.put<ICustomField>(
      `${apiUrl}/${customField.id}`,
      customField
    );
    return res.data;
  }

  async delete(customField: ICustomField): Promise<ICustomField> {
    let res = await axios.put<ICustomField>(`${apiUrl}/${customField.id}`);
    return res.data;
  }
}
